/**
 * Avatar identifiers used by the Weet AI generation pipeline.
 *
 * Values are the canonical strings expected by speacher_front (the Weet editor).
 * DO NOT rename them — they are persisted in generated speachs and passed via
 * WeetInitiator to speacher_front.
 *
 * `NO_AVATAR` / `MEG_FORMAL` / `LORI_GRACEFUL` / `MAX_CASUAL` are legacy and
 * kept for backward compatibility with older data.
 */
export enum AIAvatar {
    // Legacy — kept for backward compat with old speach content
    MEG_FORMAL = "MEG-FORMAL",
    LORI_GRACEFUL = "LORI-GRACEFUL",
    MAX_CASUAL = "MAX-CASUAL",
    NO_AVATAR = "NO_AVATAR",

    // Realistic avatars (v2)
    ABIGAIL = "Abigail",
    ARTHUR = "Arthur",
    DAN = "Dan",
    DARNEL = "Darnel",
    ELIA = "Elia",
    EVA = "Eva",
    FAIZA = "Faiza",
    HANNAH = "Hannah",
    ISABELLA = "Isabella",
    JAD = "Jad",
    JEN = "Jen",
    JESSICA = "Jessica",
    JOHN = "John",
    MARC = "Marc",
    MARIE = "Marie",
    MARTHA = "Martha",
    MICHELLE = "Michelle",
    MIKE = "Mike",
    MYA = "Mya",
    OLIVIA = "Olivia",
    RUBY = "Ruby",
    RYAN = "Ryan",
    SARAH = "Sarah",
    STEEVE = "Steeve",
    STELLA = "Stella",
    LARA = "Lara",
    LIAM = "Liam",
    ROSIE = "Rosie",
    ARABELLA = "Arabella",
    TALIA = "Talia",

    // Custom avatars
    DANA = "Dana",
    ANDY = "Andy"
}
